<template>
<v-card class="pa-6 mt-5 ml-6" max-width="300px">
  <v-card-title>
    Alterar dados do Local
  </v-card-title>

    <v-form v-model="valid" ref="form" class="pa-1">

     <v-text-field
            v-model="nomeLocal"
            :rules="nomeRules"
            :type="'text'"
            name="input-10-1"
            label="Nome do Local"
            counter
            @click:append="show1 = !show1"
       ></v-text-field>
       <v-layout row wrap>
       <v-flex xs12 sm6>
        <v-checkbox
            label="Este Local é automático?"
            v-model="automatico"
            required
          ></v-checkbox>
	    </v-flex>
    </v-layout>

    <v-checkbox
      label="Você concorda?"
      v-model="checkbox"
      :rules="[(v) => !!v || 'Você deve concordar para alterar!']"
      required
    ></v-checkbox>
    <v-alert
      :value="erroEditar"
      color="error"
      icon="warning"
      outlined
    >
      Erro ao editar o nome!
    </v-alert>

    <v-alert
      :value="sucessoEditar"
      color="success"
      icon="check_circle"
      outlined
    >
      Sucesso ao editar o nome!
    </v-alert>

  </v-form>
  <v-card-actions>
      <v-spacer/>
      <v-btn dark @click="alterarLocal" :class="{ red: !valid, green: valid }">Salvar</v-btn>
      <v-btn  @click="" to='/listaLocaisUnidade'>
      <v-icon left>keyboard_backspace</v-icon>
          voltar
      </v-btn>
    </v-card-actions>

</v-card>

</template>

<script>
// import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
// import EventBus from '../../../main';

export default {
  name: 'editarLocal',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      idLocal: '',
      automatico: false,
      sucessoEditar: false,
      isEditing: true,
      nomeLocal: '',
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 5 caracteres'
      ]
    }
  },
  mounted () {
    this.erroEditar = false,
    this.sucessoEditar = false
    if (!this.$route.params.item) {
      this.$router.push('/listaLocaisUnidade')
      return
    }

    this.nomeLocal = this.$route.params.item.nomeLocal
    this.idLocal = this.$route.params.item.idLocal
    this.automatico = this.$route.params.item.automatico
  },
  methods: {

    alterarLocal () {
      console.log('em cadastrarLocalUnidade admin unidade')
      if (this.$refs.form.validate()) {
        this.erroEditar = false
        this.sucessoEditar = false
        administradorUnidadeService.administradorUnidade
          .alterarLocal(this.idLocal, this.nomeLocal, this.automatico)
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data == true) {
              this.sucessoEditar = true
              this.clear()
              setTimeout(() => this.$router.push({ path: '/listaLocaisUnidade' }), 2000)
            }
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  }
}
</script>

<style  scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
